import {
  ClassroomDto,
  ClassroomGroupDto,
  ProgrammeTypeDto,
} from '@ecdlink/core';
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../types';

export const getClassroomForCoach = (
  state: RootState
): ClassroomDto[] | undefined => state.classroomForCoachData.classroomForCoach;

export const getProgrammeType = () =>
  createSelector(
    (state: RootState) => state,
    (rootState: RootState): ProgrammeTypeDto | undefined => {
      return rootState.staticData.programmeTypes?.find(
        (x) => x.id === rootState.classroomData.programmeType
      );
    }
  );

export const getClassroomForCoachByUserId = (userId: string) =>
  createSelector([getClassroomForCoach], (classrooms) =>
    classrooms?.find((classroom) => classroom.userId === userId)
  );

export const getClassroomGroups = (state: RootState): ClassroomGroupDto[] =>
  state.classroomData.classroomGroups?.filter((x) => x.isActive) || [];

export const getClassroomGroupById = (id?: string) =>
  createSelector(
    (state: RootState) => state.classroomData.classroomGroups,
    (classroomGroups: ClassroomGroupDto[] | undefined) => {
      if (!classroomGroups || !id) return;

      return classroomGroups.find((group) => group.id === id);
    }
  );

export const getClassroomGroupsForClassroom = (classroomId: string) =>
  createSelector(
    (state: RootState) => state.classroomForCoachData.classroomGroups,
    (classroomGroups) => {
      return (
        classroomGroups?.filter(
          (classroomGroup) => classroomGroup.classroomId === classroomId
        ) || []
      );
    }
  );

export const getClassroomGroupsForPractitioner = (userId: string) =>
  createSelector(
    (state: RootState) => state.classroomForCoachData.classroomGroups,
    (classroomGroups) => {
      return (
        classroomGroups?.filter(
          (classroomGroup) => classroomGroup.userId === userId
        ) || []
      );
    }
  );
